module.exports = __webpack_public_path__ + "static/media/logo.11f3ff1a.png";